import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartyShipperAccountReferenceService extends BaseReferenceService {
  constructor() {
    super('ThirdPartyShipperAccountReference');
  }
}
